import api from "api/flexapi";
import { showPopup } from "actions/popupActions";
import { renderAsHTML } from "utils";
import messages from "components/messagesDescription";

export const SHOW_DISCLAIMER = "SHOW_DISCLAIMER";

export const FETCH_PRODUCTS_START = "FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_ERROR = "FETCH_PRODUCTS_ERROR";

export const FETCH_PROVIDER_PRODUCTS_START = "FETCH_PROVIDER_PRODUCTS_START";
export const FETCH_PROVIDER_PRODUCTS_SUCCESS = "FETCH_PROVIDER_PRODUCTS_SUCCESS";
export const FETCH_PROVIDER_PRODUCTS_ERROR = "FETCH_PROVIDER_PRODUCTS_ERROR";

export const FETCH_PRODUCTS_DETAIL_START = "FETCH_PRODUCTS_DETAIL_START";
export const FETCH_PRODUCTS_DETAIL_SUCCESS = "FETCH_PRODUCTS_DETAIL_SUCCESS";
export const FETCH_PRODUCTS_DETAIL_ERROR = "FETCH_PRODUCTS_DETAIL_ERROR";

export const FETCH_PROVIDER_DETAIL_START = "FETCH_PROVIDER_DETAIL_START";
export const FETCH_PROVIDER_DETAIL_SUCCESS = "FETCH_PROVIDER_DETAIL_SUCCESS";
export const FETCH_PROVIDER_DETAIL_ERROR = "FETCH_PROVIDER_DETAIL_ERROR";

export const FETCH_PROVIDER_DETAIL_PRODUCT_START = "FETCH_PROVIDER_DETAIL_PRODUCT_START";
export const FETCH_PROVIDER_DETAIL_PRODUCT_SUCCESS = "FETCH_PROVIDER_DETAIL_PRODUCT_SUCCESS";
export const FETCH_PROVIDER_DETAIL_PRODUCT_ERROR = "FETCH_PROVIDER_DETAIL_PRODUCT_ERROR";
export const CLEAR_FETCH_PROVIDER_PRODUCTS = "CLEAR_FETCH_PROVIDER_PRODUCTS";

export const FETCH_CATEGORIES_START = "FETCH_CATEGORIES_START";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR";

export const FETCH_CATEGORY_PRODUCTS_START = "FETCH_CATEGORY_PRODUCTS_START";
export const FETCH_CATEGORY_PRODUCTS_SUCCESS = "FETCH_CATEGORY_PRODUCTS_SUCCESS";
export const FETCH_CATEGORY_PRODUCTS_ERROR = "FETCH_CATEGORY_PRODUCTS_ERROR";

export const SEARCH_PRODUCTS_START = "SEARCH_PRODUCTS_START";
export const SEARCH_PRODUCTS_SUCCESS = "SEARCH_PRODUCTS_SUCCESS";
export const SEARCH_PRODUCTS_ERROR = "SEARCH_PRODUCTS_ERROR";
export const SEARCH_MORE_PRODUCTS_START = "SEARCH_MORE_PRODUCTS_START";
export const SEARCH_MORE_PRODUCTS_SUCCESS = "SEARCH_MORE_PRODUCTS_SUCCESS";
export const SEARCH_MORE_PRODUCTS_ERROR = "SEARCH_MORE_PRODUCTS_ERROR";

export const UPDATE_SEARCH_VALUE = "UPDATE_SEARCH_VALUE";
export const CLEAR_SEARCH_VALUE = "CLEAR_SEARCH_VALUE";
export const SEND_OFFER_EMAIL_START = "SEND_OFFER_EMAIL_START";
export const SEND_OFFER_EMAIL_SUCCESS = "SEND_OFFER_EMAIL_SUCCESS";
export const SEND_OFFER_EMAIL_ERROR = "SEND_OFFER_EMAIL_ERROR";

export const markDisclaimerShown = () => dispatch => {
  dispatch({ type: SHOW_DISCLAIMER });
};

export const searchProducts = (params, seeMore = false) => dispatch => {
  dispatch({ type: seeMore ? SEARCH_MORE_PRODUCTS_START : SEARCH_PRODUCTS_START });

  api
    .getMarketplaceProducts(params)
    .then(res => {
      dispatch({
        type: seeMore ? SEARCH_MORE_PRODUCTS_SUCCESS : SEARCH_PRODUCTS_SUCCESS,
        payload: { params, data: res.body || [] },
      });
    })
    .catch(err => {
      dispatch({
        type: seeMore ? SEARCH_MORE_PRODUCTS_ERROR : SEARCH_PRODUCTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchProviderProducts = (providerId, params) => dispatch => {
  dispatch({ type: FETCH_PROVIDER_PRODUCTS_START });

  api
    .getProviderProducts(providerId, params)
    .then(res => {
      dispatch({
        type: FETCH_PROVIDER_PRODUCTS_SUCCESS,
        payload: { params, data: res.body || [] },
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_PROVIDER_PRODUCTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchProducts = params => dispatch => {
  dispatch({ type: FETCH_PRODUCTS_START });

  api
    .getMarketplaceProducts(params)
    .then(res => {
      dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: { params, data: res.body || [] },
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_PRODUCTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchCategories = () => dispatch => {
  dispatch({ type: FETCH_CATEGORIES_START });
  api
    .getMarketCategories()
    .then(res => {
      dispatch({
        type: FETCH_CATEGORIES_SUCCESS,
        payload: res.body || [],
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_CATEGORIES_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchProductDetail = productId => dispatch => {
  dispatch({ type: FETCH_PRODUCTS_DETAIL_START });

  api
    .getMarketplaceProductDetails(productId)
    .then(res => {
      dispatch({
        type: FETCH_PRODUCTS_DETAIL_SUCCESS,
        payload: res.body || [],
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_PRODUCTS_DETAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchProviderDetail = providerId => dispatch => {
  dispatch({ type: FETCH_PROVIDER_DETAIL_START });

  api
    .getMarketplaceProviderDetails(providerId)
    .then(res => {
      dispatch({
        type: FETCH_PROVIDER_DETAIL_SUCCESS,
        payload: res.body || [],
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_PROVIDER_DETAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchProviderDetailProducts = providerId => dispatch => {
  dispatch({ type: FETCH_PROVIDER_DETAIL_PRODUCT_START });

  api
    .getMarketplaceProviderDetailsProducts(providerId)
    .then(res => {
      dispatch({
        type: FETCH_PROVIDER_DETAIL_PRODUCT_SUCCESS,
        payload: res.body || [],
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_PROVIDER_DETAIL_PRODUCT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const fetchCategoryProducts = (categoryId, params) => dispatch => {
  dispatch({ type: FETCH_CATEGORY_PRODUCTS_START, payload: { categoryId, params } });

  api
    .getMarketplaceCategoryProducts(categoryId, params)
    .then(res => {
      dispatch({
        type: FETCH_CATEGORY_PRODUCTS_SUCCESS,
        payload: { categoryId, data: res.body || [] },
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_CATEGORY_PRODUCTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const updateSearchValue = searchValue => dispatch => {
  dispatch({ type: UPDATE_SEARCH_VALUE, payload: searchValue });
};

export const clearSearchValue = () => dispatch => {
  dispatch({ type: CLEAR_SEARCH_VALUE });
};

export const clearProviderProducts = () => dispatch => {
  dispatch({ type: CLEAR_FETCH_PROVIDER_PRODUCTS });
};

export const sendOfferEmail = (productId, intl) => dispatch => {
  dispatch({ type: SEND_OFFER_EMAIL_START });
  api
    .sendProductOfferByEmail(productId)
    .then(res => {
      if (res.body.offerEmailCount > 10) {
        dispatch({
          type: SEND_OFFER_EMAIL_ERROR,
        });

        dispatch(
          showPopup({
            element: renderAsHTML(
              "div",
              intl.formatMessage(messages.marketplace.sendEmailOfferLimitMessage)
            ),
          })
        );
      } else {
        dispatch({
          type: SEND_OFFER_EMAIL_SUCCESS,
        });

        dispatch(
          showPopup({
            element: renderAsHTML(
              "div",
              intl.formatMessage(messages.marketplace.sendEmailOfferMessage)
            ),
          })
        );
      }
    })
    .catch(err => {
      dispatch({
        type: SEND_OFFER_EMAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/marketplaceActions.js